import { getCookie } from 'tiny-cookie'

import { isLoggedIn } from '@/state/Authentication'
import { cartExpired, refreshStoredCart } from '@/state/Cart'
import store from '@/store/store'

export function initializeStores(): void {
  store.dispatch('Member/clearLegacy')
  const hasSessionCookie = getCookie('session_expires')

  if (isLoggedIn() && !hasSessionCookie) {
    // The session has expired. Clear all storage, but stay on the current URL.
    store.dispatch('clearAll')
  } else {
    initializeCartStore()

    // Always fetch fresh membership data if there is a valid session cookie. This prevents stale data from being displayed across tabs. It also enables integration with external authentication methods that set the session cookie.
    if (hasSessionCookie) store.dispatch('Member/load')
  }
}

/**
 * Removes any known carts that have expired, are empty, or not pending (purchased/deleted elsewhere).
 * Seeds a Stripe wallet payment to check if digital wallets are supported before getting to checkout.
 */
function initializeCartStore(): void {
  if (cartExpired()) {
    store.dispatch('Cart/clearAll')
  } else if (store.getters['Cart/cart']) {
    // Reload the cart, which also confirms it is still valid.
    refreshStoredCart()
  }
}
